<div class=" modalAdd" id="viewRejectedMessages">
    <div class="add_another_waste_modal waste_popup_modal add_view_reject_popup_modal">
        <div class="">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Rejected Request(s)</h3>
                    <img style="margin-top:2px" src="assets/images/close.svg" class="close" alt="close botton" mat-dialog-close>
                    
                </div>
            </div>
            <div class="waste_modal_content cf nopadding" style="background: white;">
                <table class="table_view_reject_modal" aria-describedby="">
                    <thead>
                        <tr>
                            <th id="">Calibration Time</th>
                            <th id="">Product Name</th>
                            <th id="">Request Type</th>
                            <th id="">Rejection Reason</th>
                            <th id="">Rejected Time</th>
                            <th id=""><button class="prim-button-link" style="font-size: 12px;padding: 0px;" (click)="clear(notificationData,true)">Clear
                                    ALL</button></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let messDetailObj of notificationData">
                            <td>{{messDetailObj.calibrationTime}}</td>
                            <td>{{messDetailObj.productName}}</td>
                            <td>{{messDetailObj.orderType}}</td>
                            <td>{{messDetailObj.rejectResonDesc}}</td>
                            <td>{{messDetailObj.rejectTime}}</td>
                            <td><button class="prim-button-link" style="font-size: 12px;padding: 0px;"(click)="clear([messDetailObj],false)">Clear</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <!-- SB-4993 -->
                    <p class="add_view_reject_popup_p">* Your Nuctrac procedure change is updated. The pharmacy rejected
                        the order modification. <u>Please contact the pharmacy for more information </u> </p>
                </div>

            </div>

        </div>

    </div>
</div>